import React from 'react';

import FormElement from 'Components/Core/Form/FormElement';
import ModuleTable from 'Components/Core/ModuleTable';
import BooleanIcon from 'Components/Core/BooleanIcon';
import './MemberList.css';

export default function MemberListBasis(props) {

	const x = props.x;

	function onAfterSend(result) {
		if (result.returncode === 1) {
			const wafId = props.id;
			x.waf.set(wafId, 'member-name', '');
			x.waf.set(wafId, 'member-mail', '');
			x.waf.focus(wafId, 'member-name');
		}
	}

	function onFormSubmit(event) {
		event.preventDefault();
		const wafId = props.id;
		if (!x.wau.validMail(x.waf.get(wafId, 'member-mail'))) {
			x.waf.set(wafId, 'message', 'Bitte eine gültige Mailadresse angeben.');
			x.waf.show(wafId, 'message');
			return;
		}
		x.waf.hide(wafId, 'message');
		x.waf[wafId].ok(event);
	}

	/*
	const [error, setError] = React.useState(false);
	const [message, setMessage] = React.useState('');

	function onAfterSend(result) {
		if (result.returncode === 1) {
			x.wah.addHint('Benutzer angelegt...');
			setError(false);
			setMessage(<div>Benuter angelegt.<br/> <div>{'Temporäres Kennwort: '}<br/> {result.content.password} </div></div> );
			x.wab['member-listing'].reload();
		}
		else {
			setError(true);
		}
	}
	*/

	return (
		<ModuleTable
			id={props.id}
			tableId="sectionId"
			x={x}
			classes={`module-member-list `}
			tableClasses={`member-list `}
			title={props.title}
			addTitle="Neues Mitglied anlegen"
			module="Member"
			listTask="MemberList"
			formFields = {
				<>
					<FormElement x={x}   wafId={props.id} id="member-name" title="Pseudonym"  />
					<FormElement x={x}   wafId={props.id} id="member-mail" title="Mail" mandatory={true} />
				</>
			}
			focusField="member-name"
			formSendTask="AddMember"
			onFormSubmit={onFormSubmit}
			onAfterSend={onAfterSend}
			onAddHeader={(addHeader) => {
				addHeader('ID');
				addHeader('Pseudonym');
				addHeader('Letzte Anmeldung');
				addHeader('Letzter Zugriff');
				addHeader('Gesperrt');
				addHeader('Beiträge');
			}}
			onAddColumn={(key, value) => {  
				switch (key) {
					case 'memberid':
					case 'membername':
					case 'lastlogin':
					case 'lastrequest':
					case 'postingcount':
						return value;
					case 'locked':
						return <BooleanIcon value={value} />;
					default:
						return false;
				}
			}}
			onEditRow={(e, rowFields, rowId) => {
				e.preventDefault();
				x.wam.openPrivateForum(rowFields.memberid, rowFields.membername, rowFields.memberlevel);
			}}
		/>
	)
};

